<div class="jeopardy-question-grid">
@if(questionLoaded){
  <div class="players" [class.two-players]="players.length === 2">
    @for (player of players; track $index; let i = $index) {
    <div style="position: relative;">
      <div class="player-avatar" [class.active]="players.length === 1 || player.isActivePlayer"
           [class.wrong-answer]="player.wrongAnswer" [class.correct-answer]="player.correctAnswer">
        <img [src]="'assets/app-branding/img/avatars/cartoon/' + player.avatar"
             [alt]="i18n.str('challengeu.avatar_picture', 'Your avatar picture')()" />
        @if (player.wrongAnswer || player.correctAnswer) {
        <div [class.score-downgrade]="player.wrongAnswer" [class.score-upgrade]="player.correctAnswer">
          {{scoreDifference}}
        </div>
        }
      </div>
      <p class="player-name">{{ player.isCurrentPlayer ? 'You' : player.name }}</p>
      <p class="player-points">{{ player.score }} {{ i18n.str('challengeu.question_points', 'points')() }}</p>
    </div>
    }
  </div>
  @if (questionLoaded) {
  <div class="question-image">
    <div class="jeopardy-box">
      <div class="image-h" [attr.aria-label]="question?.mediaDescription"[title]="question?.mediaDescription" [ngStyle]="{'background-image': 'url(' + question?.mediaUrl + ')'}">
        <div class="topic">
          <img [src]="topicIconUrl(question?.topic)" [alt]="question?.mediaDescription">
          <span>{{ question?.topic }}</span>
        </div>
        <div class="topic right">
          <img [src]="questionDifficulty?.imagePath" [alt]="questionDifficulty?.points">
          <span>{{i18n.str('challengeu.question_points', 'points')()}}</span>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="question-text">
    {{question?.text}}
  </div>
  <div class="flip">
    <div class="flip-inner" [class.flipped]="showExplanation">
      <div class="flip-front question-answers">
        @for (choice of choices; track choice; let i = $index) {
        <p class="answer jeopardy-button primary"
           [class.success]="questionAnswered && (correctAnswerSelected && selectedAnswerIndex === i) || (!correctAnswerSelected && trueAnswerIndex === i)"
           [class.secondary]="questionAnswered && !correctAnswerSelected && selectedAnswerIndex === i"
           [class.disabled]="questionAnswered && trueAnswerIndex !== i && selectedAnswerIndex !== i || disabledAnswers.includes(choice.text)"
           [class.processing]="processingAnswer && selectedAnswerIndex === i">
          <a href="#" (click)="selectAnswer($event, i, true)">
            {{choice.text}}
          </a>
        </p>
        }
      </div>
      @if(showExplanation){
      <div class="flip-back">
        <div class="question-explanation">
          <div class="explanation-content">
            <p>{{i18n.str('challengeu.question_right_answer', 'THE CORRECT ANSWER IS:')()}}</p>
            <h3 class="title">{{correctAnswer?.text}}</h3>
            <p class="description" [innerHTML]="correctAnswer?.explanation"></p>
          </div>
        </div>
        @if (!nextButtonActive) {
        <p>
          {{i18n.str('challengeu.msg_waiting_round_end', 'Waiting for round to end')()}}
        </p>
        }
        @if (nextButtonActive && nextRound && nextRound.activeUser.userId !== connectedPlayer.userId) {
        <p>
          {{i18n.str('challengeu.msg_waiting_for', 'Waiting for')()}} {{nextRound.activeUser.name}}
          {{i18n.str('challengeu.msg_waiting_pick_topic', 'to pick the topic')()}}
        </p>
        }

        @if (nextButtonActive && nextRound && nextRound.activeUser.userId === connectedPlayer.userId) {
        <p class="jeopardy-button primary">
          <a class="neon" href="#"
             title="{{isLastQuestion ? i18n.str('challengeu.btn_see_results', 'SEE RESULTS')() : i18n.str('challengeu.question_continue', 'CONTINUE')()}}"
             (click)="nextQuestion($event)">
            @if (!isLastQuestion) {
            <span>{{i18n.str('challengeu.question_continue', 'CONTINUE')()}}</span>
            }
            @else {
            <span>{{i18n.str('challengeu.btn_see_results', 'SEE RESULTS')()}}</span>
            }
          </a>
        </p>
        }

        @if (isLastQuestion) {
        <p class="jeopardy-button primary" [class.disabled]="!nextButtonActive">
          <a class="neon" href="#"
             title="{{isLastQuestion ? i18n.str('challengeu.btn_see_results', 'SEE RESULTS')() : i18n.str('challengeu.btn_next', 'NEXT')()}}"
             (click)="nextQuestion($event)">
            @if (!isLastQuestion) {
            <span>{{i18n.str('challengeu.btn_next', 'NEXT')()}}</span>
            }
            @else {
            <span>{{i18n.str('challengeu.btn_see_results', 'SEE RESULTS')()}}</span>
            }
          </a>
        </p>
        }
      </div>
      }
    </div>
  </div>

  <div class="question-tokens-timer">
    @if (!showExplanation) {
    <div class="answer-tokens">
      <div [class.disabled]="fiftyTokenDisabled">
        <a href="#" (click)="use5050token($event)">
          <img src="assets/app-branding/img/question/Icon-joker2.png"
               alt="{{i18n.str('challengeu.question_50_token', 'Hide 2 wrong answers')()}}" s />
          <!-- <span>x2</span> -->
        </a>
        <p class="joker-title">{{i18n.str('challengeu.question_50_token', 'Hide 2 wrong answers')()}}</p>
      </div>
      <div>
        <app-countdown [seconds]="questionTime" [radius]="85" [size]="200" [events]="stopCountdownEvent.asObservable()"
                       [roundTimeStart]="roundTimeStart$" (timeExpired)="noAnswerProvided()"></app-countdown>
      </div>
      <div [class.disabled]="skipTokenDisabled">
        <a href="#" (click)="useSkipQuestionToken($event)">
          <img src="assets/app-branding/img/question/Icon-skipquestion.png"
               alt="{{i18n.str('challengeu.question_skip_token', 'Skip this question')()}}" />
          <!-- <span>x2</span> -->
        </a>
        <p class="joker-title">{{i18n.str('challengeu.question_skip_token', 'Skip this question')()}}</p>
      </div>
    </div>
    }
  </div>
}
</div>
